<p-dialog
  [visible]="visible()"
  (visibleChange)="!$event && close()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!sending()"
  appendTo="body"
  [style]="{ width: 'min(48rem, calc(100vw - 2rem))' }"
  styleClass="mit-charge-dialog">
  <ng-template #header>
    <div class="flex items-center gap-3 min-w-0">
      <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-sky-100 text-sky-700">
        <i class="pi pi-credit-card text-lg" aria-hidden="true"></i>
      </span>
      <div class="min-w-0">
        <h2 class="text-lg font-semibold text-slate-900 m-0">Cobrar</h2>
        @if (mandate(); as m) {
          <p class="text-sm text-slate-500 m-0 truncate">
            {{ m.number }}@if (m.customerName) { · {{ m.customerName }} }@if (m.card?.lastDigits) { · {{ m.card?.brand || 'Tarjeta' }} •••• {{ m.card?.lastDigits }} }
          </p>
        }
      </div>
    </div>
  </ng-template>
  @if (result(); as tx) {
    <div class="flex flex-col gap-3">
      @switch (outcome()) {
        @case ('approved') {
          <div class="rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-3">
            <p class="text-sm font-semibold text-emerald-800 m-0">Cobro aprobado por {{ tx.amount | currency:(tx.currencyCode || 'MXN'):'symbol-narrow' }}</p>
            @if (tx.saleNumber) {
              <p class="text-sm text-emerald-700 m-0 mt-1">
                Venta <a [routerLink]="['/sales', tx.saleId]" class="underline font-medium" (click)="close()">{{ tx.saleNumber }}</a>
              </p>
            } @else if (tx.materializationError) {
              <p class="text-xs text-amber-700 m-0 mt-1">El cobro se aprobó; la venta se está registrando.</p>
            }
          </div>
        }
        @case ('declined') {
          <div class="rounded-lg border border-red-200 bg-red-50 px-4 py-3">
            <p class="text-sm font-semibold text-red-800 m-0">Declinado por el banco</p>
            <p class="text-sm text-red-700 m-0 mt-1">{{ tx.providerMessage || 'La tarjeta no autorizó el cargo.' }}</p>
          </div>
        }
        @case ('rejected') {
          <div class="rounded-lg border border-red-200 bg-red-50 px-4 py-3">
            <p class="text-sm font-semibold text-red-800 m-0">Rechazado: {{ rejectionText(tx) | lowercase }}</p>
            <p class="text-xs text-red-700 m-0 mt-1">No se envió al banco.</p>
          </div>
        }
        @default {
          <div class="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3">
            <p class="text-sm font-semibold text-amber-800 m-0">En revisión</p>
            <p class="text-sm text-amber-700 m-0 mt-1">
              No tenemos aún la respuesta del banco. No intentes cobrar de nuevo: se confirmará automáticamente o lo resolverá Pento.
            </p>
          </div>
        }
      }
      <a [routerLink]="['/mit-transactions', tx.id]" class="text-sm text-sky-700 hover:underline" (click)="close()">Ver transacción</a>
    </div>
  } @else {
    <form [formGroup]="form" (ngSubmit)="submit()" class="flex flex-col gap-4">
      <p-floatlabel class="w-full" variant="on">
        <input pInputText id="mitChargeConcept" formControlName="concept" maxlength="250" class="w-full" />
        <label for="mitChargeConcept">Concepto *</label>
      </p-floatlabel>
      <p-floatlabel class="w-full" variant="on">
        <input pInputText id="mitChargeReference" formControlName="externalReference" maxlength="100" class="w-full" />
        <label for="mitChargeReference">Referencia externa</label>
      </p-floatlabel>
      <app-mit-charge-lines-fields [lines]="lines" idPrefix="mit-charge" />
      @if (error()) {
        <p class="text-sm m-0" [class.text-red-600]="!networkFailed()" [class.text-amber-700]="networkFailed()">{{ error() }}</p>
      }
    </form>
  }
  <ng-template #footer>
    <div class="flex justify-end gap-2">
      <p-button [label]="result() ? 'Cerrar' : 'Cancelar'" severity="secondary" [text]="true" type="button" [disabled]="sending()" (onClick)="close()" />
      @if (result()) {
        @if (outcome() === 'declined' || outcome() === 'rejected') {
          <p-button label="Nuevo cobro" icon="pi pi-plus" type="button" (onClick)="startNew()" />
        }
      } @else if (networkFailed()) {
        <p-button label="Reintentar" icon="pi pi-refresh" type="button" [loading]="sending()" (onClick)="retry()" />
      } @else {
        <p-button label="Cobrar" icon="pi pi-credit-card" type="button" [loading]="sending()" [disabled]="sending()" (onClick)="submit()" />
      }
    </div>
  </ng-template>
</p-dialog>
